import { DictionaryType } from '@iw/core/helpers';

export const TAB = {
  DESCRIPTION: 'description',
  MESSAGES: 'messages',
} as const;

export type TabType = DictionaryType<typeof TAB>;

export interface OrderDetailsDialogData {
  id: string;
  tab?: TabType;
}
